import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { LoanTapeView } from '~/capitalProvider/domains/settings/loantape/LoanTapeView';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

// Types
const RouteParamsStruct = z.object({
  creditFacilityId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { creditFacilityId } = RouteParamsStruct.parse(params);
  return <LoanTapeView creditFacilityId={creditFacilityId} />;
};

// Exports
const permissions: PermissionsFn = (context) => {
  if (!context.flags.enableLenderBaseFieldEdits) return 'deny';
  return 'allow';
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/settings/credit-facilities" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/credit-facilities" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  </PermissionGuard>
);
